/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from "react";
import { PropTypes } from "prop-types";

const ContactFormReusable = ({
  handlerSetComponents,
  components,
  id,
  reusableComponent,
}) => {
  const initialState = {
    type: 'ContactFormReusable',
    events: '',
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);

  const inputHandler = e => {
    const { value, name } = e.target;

    const { component } = components[index];
    const comp = {
      ...component,
      [name]: value
    };
    setState(comp);

    const componentObj = {
      id,
      component: comp
    };

    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    setIndex(componentIndex);
    if (component) {
      setState(component);
    } else {
      const componentObj = {
        id,
        component: state
      };
      handlerSetComponents(componentObj, componentIndex);
    }
  }, [components]);

  return (
    <div className="w-full px-4 bg-greyFilter rounded-lg">
      <div className="flex w-full pb-1">
        <label
          htmlFor="events"
          className="flex font-americaMonoRegular text-xs uppercase items-start text-black w-full mx-1 mt-1 pl-10 flex-col"
        >
          <span className="ml-0">Event to contact</span>
          <input
            className="mt-1 font-americaMonoRegular p-2 bg-white outline-none w-full rounded-full"
            onChange={inputHandler}
            name="events"
            type="text"
            value={state.events}
            readOnly={reusableComponent && reusableComponent}
          />
        </label>
      </div>
    </div>
  );
};

ContactFormReusable.propTypes = {
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  reusableComponent: PropTypes.shape()
};
ContactFormReusable.defaultProps = {
  reusableComponent: null
};

export default ContactFormReusable;
